module.exports = __webpack_public_path__ + "img/veh-back.png";